import { render, staticRenderFns } from "./add-edit-device-config.vue?vue&type=template&id=38fc8728&scoped=true"
import script from "./add-edit-device-config.vue?vue&type=script&lang=js"
export * from "./add-edit-device-config.vue?vue&type=script&lang=js"
import style0 from "./add-edit-device-config.vue?vue&type=style&index=0&id=38fc8728&prod&lang=scss"
import style1 from "./add-edit-device-config.vue?vue&type=style&index=1&id=38fc8728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc8728",
  null
  
)

export default component.exports